import React from 'react';
import useSearchParams from '../useSearchParams';
import moment from 'moment';

export const DateRangeSelector: React.FC = () => {
  const {query, setQuery} = useSearchParams();

  const startDate =
    query.startDate ?? moment().subtract(2, 'weeks').format('YYYY/MM/DD');
  const endDate = query.endDate ?? moment().format('YYYY/MM/DD');

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery({startDate: moment(e.target.value).format('YYYY/MM/DD')});
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery({endDate: moment(e.target.value).format('YYYY/MM/DD')});
  };

  return (
    <div className="flex items-center gap-1">
      <input
        type="date"
        value={moment(startDate, 'YYYY/MM/DD').format('YYYY-MM-DD')}
        onChange={handleStartDateChange}
        className="w-[100px] h-8 px-2 text-xs border border-c-border rounded bg-white text-c-text-primary"
      />
      <span className="text-xs text-c-text-primary">〜</span>
      <input
        type="date"
        value={moment(endDate, 'YYYY/MM/DD').format('YYYY-MM-DD')}
        onChange={handleEndDateChange}
        className="w-[100px] h-8 px-2 text-xs border border-c-border rounded bg-white text-c-text-primary"
      />
    </div>
  );
};
